import { Component, OnInit, OnDestroy } from '@angular/core';
import { SupersetDashboardService } from '../service/superset-dashboard.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeService } from 'src/app/shared/services/home.service';
import { SidePanelService } from 'src/app/shared/services/side-pannel/side-pannel.service';
import { Subscription } from 'rxjs-compat';


@Component({
  selector: 'app-superset',
  templateUrl: './superset.component.html',
  styleUrls: ['./superset.component.scss']
})
export class SupersetComponent implements OnInit, OnDestroy {
  currentDashboardId: string = ''
  currentDashboardTitle: string = '';
  private routeSub: Subscription;

  constructor(
    public supersetDashboardService:SupersetDashboardService,
    private route:ActivatedRoute,
    private router:Router,
    public homeService:HomeService,
    
  ) { }

  ngOnInit(): void {
    this.setupRouteSubscription();
    
  }

  

  private setupRouteSubscription(): void {
    this.routeSub = this.route.paramMap.subscribe(params => {
      const dashboardId = params.get('id');
      this.currentDashboardId = dashboardId;
      this.currentDashboardTitle = params.get('name');
    });
  }

  

  ngOnDestroy(): void {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }

  navigateToSuperSetMenuDash(){
    this.router.navigate(['/dash-suite']);
  }

}
